@import '../../../../globals/main';

pn-video-overlay {
  &.pn-video-overlay--show-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(13, 35, 75, 0.68) 7%, rgba(13, 35, 75, 0) 80%);
  }

  button {
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 0;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: transparent;

    @media screen and (min-width: $min-width-md) {
      bottom: 16px;
      left: 16px;
    }

    &:hover {
      svg rect {
        fill: darken(#005d92, 10%);
      }
    }

    &:active {
      svg rect {
        fill: darken(#005d92, 20%);
      }
    }

    &:focus,
    &:focus-visible {
      outline: 2px solid $white;
    }

    svg {
      scale: 0.7;
      @media screen and (min-width: $min-width-md) {
        scale: 1;
      }
    }
  }
}
